export const HOUSE_ROUNDED_DRAWING = require("@/assets/img/optimized/house.webp")
export const JPG_DOCUMENT = require("@/assets/img/optimized/jpg-icon.webp")
export const INFO_CARD_IMAGE = require("@/assets/img/optimized/child-in-class.webp") // unsplash.com/photos/O5EMzfdxedg
export const KINDERGARDEN_MEDIA_PLACEHOLDER = require("@/assets/img/optimized/children-boots.webp") // unsplash.com/photos/iDCtsz-INHI
export const BACKGROUNDS = {
  error: require("@/assets/img/optimized/surprised.webp"), // unsplash.com/photos/qDY9ahp0Mto
  welcome: require("@/assets/img/optimized/welcome.webp"),
  managementDashboard: require("@/assets/img/optimized/Liquid-Cheese.svg"), // background by SVGBACKGROUNDS.com
  navbar: require("@/assets/img/optimized/navbar.webp"),
}
